import React from 'react'

export const Unauthorized = () => {
  return (
    <div>
      <p>...Unauthorized</p>
    </div>
  )
}

